import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify, {
  VAutocomplete,
  VAlert,
  VSnackbar,
  VBtn,
  VIcon,
  VRow,
  VCol,
  VCombobox,
  VTextField,
  VTooltip,
  VCheckbox,
  VTextarea,
  VSelect,
  VFileInput,
  VSwitch
} from 'vuetify/lib'

import {
  Ripple,
  Intersect,
  Touch,
  Resize,
  ClickOutside
} from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  components: {
    VAutocomplete,
    VAlert,
    VSnackbar,
    VBtn,
    VIcon,
    VRow,
    VCol,
    VCombobox,
    VTextField,
    VTextarea,
    VTooltip,
    VCheckbox,
    VFileInput,
    VSelect,
    VSwitch
  },
  directives: {
    Ripple,
    Intersect,
    Touch,
    Resize,
    ClickOutside
  }
})

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: '#673ab7',
        secondary: '#125B9B',
        accent: '#ffc107',
        error: '#f44336',
        warning: '#ff9800',
        info: '#9c27b0',
        success: '#4caf50'
      }
    },
    options: {
      customProperties: true
    }
  },

  icons: {
    iconfont: 'mdi'
  }
})
